import styled from "styled-components/macro";

import { Cell } from "./";

export const TotalColumnCell = styled(Cell)`
  min-width: 150px;
  max-width: 300px;
  overflow: hidden;
  box-sizing: border-box;
`;
